module.exports = __webpack_public_path__ + "static/img/e-commerce-primary.96b6453c.svg";